export const COUNTRY_CODES = [
  { code: "+1", iso: "us", label: "US" },
  { code: "+44", iso: "gb", label: "UK" },
  { code: "+61", iso: "au", label: "AU" },
  { code: "+33", iso: "fr", label: "FR" },
  { code: "+49", iso: "de", label: "DE" },
  { code: "+81", iso: "jp", label: "JP" },
  { code: "+86", iso: "cn", label: "CN" },
  { code: "+91", iso: "in", label: "IN" },
  { code: "+55", iso: "br", label: "BR" },
  { code: "+52", iso: "mx", label: "MX" },
  { code: "+971", iso: "ae", label: "AE" },
  { code: "+966", iso: "sa", label: "SA" },
  { code: "+65", iso: "sg", label: "SG" },
  { code: "+82", iso: "kr", label: "KR" },
  { code: "+39", iso: "it", label: "IT" },
  { code: "+34", iso: "es", label: "ES" },
  { code: "+7", iso: "ru", label: "RU" },
  { code: "+41", iso: "ch", label: "CH" },
];

export const FlagImg = ({ iso, className = "" }) => (
  <img
    src={`https://flagcdn.com/w40/${iso}.png`}
    srcSet={`https://flagcdn.com/w80/${iso}.png 2x`}
    alt={iso.toUpperCase()}
    className={`inline-block rounded-full object-cover ${className}`}
    width={20}
    height={20}
    style={{ aspectRatio: "1/1" }}
  />
);
